define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("CancelOffline", _StateAction, {
		_bLatestRevision: false,
		m_module: "Sourcing",
		m_tag: "CancelOffline",

		hasAccess: function(/*Context*/ctx) {
			//Note: C8-1285: for UI optimization, checking of contextual roles will be done by the server logic

			var master = ctx.getNodeParent();
			//  "Cancel Offline" action should be available only on the current revision
			if (!master || !master.Offline || !ctx.getNode().IsCurrent) return false; //S10685: Restrict actions on SupplierItem when it is offline

			return this.inherited(arguments);
		},

		isAvailableOffline: function(/*Context*/ctx) {
			return true;
		}
	});
});